/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import OktaAuthRef from "../auth/okta";
import UserHelper from "../utils/user-helper";
import Routes from "./routes";
// import AuthService from '@/services/AuthService'
// import axios from 'axios'

Vue.use(Router);

const router = new Router(Routes);

// router.beforeEach(navigationGuard)

router.beforeEach((to, from, next) => {
  const idToken = OktaAuthRef.getAccessToken();
  if (to.path === "/") {
    next({ name: "Login" });
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // Secured route
      if (UserHelper.checkIfHasPosAdminAccess()) {
        if (to.path === "/pos-admin" && to.path === "/pos-admin/") {
          next({ name: "Dashboard" });
        } else {
          if (to.path.indexOf("/pos-admin") > -1) {
            next();
          } else {
            next({ name: "Manage Clinics" });
          }
        }
      } else {
        if (to.path === "/admin" && to.path === "/admin/") {
          next({ name: "Dashboard" });
        } else {
          if (to.path.indexOf("/admin") > -1) {
            next();
          } else {
            next({ name: "Dashboard" });
          }
        }
      }
    } else {
      // Not secured route
      if (idToken && (to.path.indexOf("auth") > -1 || to.path.indexOf("login") > -1)) {
        // Logged in
        // But Trying to navigate to login / auth pages
        // SO redirect to dashboard
        if (UserHelper.checkIfHasPosAdminAccess()) {
          next({ name: "Manage Clinics" });
        } else {
          next({ name: "Dashboard" });
        }
      } else {
        next();
      }
    }
  }
});

export default router;
